import React, { useContext } from "react";
import { saveAs } from "file-saver";
import { Stack, Typography, Button, Grid } from "@mui/material";
import { Download } from "@mui/icons-material";

import { AppContext } from "../../context/AppProvider";

export const License = (props) => {
  const { license } = useContext(AppContext);

  const download = () => {
    const blob = new Blob([license.key], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `kasm-license.txt`);
  }

  return (
    <Grid container>
      <Grid item md={6} className="form">
        <Stack direction="column" spacing={3}>
          <Typography variant="h4">Thank you!</Typography>
          <Typography variant="body">A license key was generated for you:</Typography>
          <Stack direction="row" alignItems="center" justifyContent="start">
            <Button
              sx={{ marginTop: '10px' }}
              size="large"
              variant="contained"
              endIcon={<Download />}
              onClick={download}>
              Download
            </Button>
          </Stack>
        </Stack>

      </Grid>

      <Grid item md={6} className="summary">
        <div className="summary-holder">
          <div className="summary-box">
            <pre contentEditable={true} style={{ fontSize: '14px', lineHeight: '1.5', border: 'none', background: 'transparent' }}>{license.key}</pre>
          </div>
          <Button
            sx={{ marginTop: '30px' }}
            size="large"
            variant="contained"
            endIcon={<Download />}
            onClick={download}
          >
            Download
          </Button>

        </div>
      </Grid>
    </Grid>
  );
}